module.exports = __webpack_public_path__ + "img/call.b2b80c92.svg";